import { useEffect, useRef } from 'react';
import { Main, Section } from 'layout/Console';
import { useRouter } from 'next/router';

const HomePage = () => {
  const router = useRouter();
  const initialPath = useRef(null);

  useEffect(() => {
    const { asPath, pathname } = router;
    if (initialPath.current === null) initialPath.current = asPath;
    if (pathname === '/' && pathname !== asPath) router.replace(asPath);
  }, [router.asPath]);

  console.log('router', router);

  return (
    <Main>
      <Section spacing={2} />
    </Main>
  );
};

export default HomePage;
